<template>
  <div style="display: flex; width: 100%" class="workBench">
    <el-aside width="200px">
      <el-menu
        class="el-menu-vertical-demo"
        :default-active="activeIndex"
        text-color="#555"
        @select="handleSelect"
      >
        <el-submenu index="1">
          <template #title>
            <span>{{ menuList.name }}</span>
          </template>
          <el-menu-item
            v-for="(item1, index1) in menuList.children"
            :key="index1"
            :index="item1.path"
          >
            <span>{{ item1.name }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      activeIndex: "",
      menuList: {},
      tabsList: [],
    };
  },
  mounted() {
    this.changeMenu();
    this.activeIndex = this.$route.name;
  },
  methods: {
    handleSelect(currentName) {
      //   console.log(this.activeIndex);
      //   console.log(currentName, this.$route);
      this.activeIndex = currentName;
      if (currentName == this.$route.name) return;
      this.$router
        .push({
          name: currentName,
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeMenu() {
      this.tabsList = JSON.parse(localStorage.getItem("tabsList"));
      this.tabsList.forEach((item, index) => {
        if (
          item.path ==
          this.$route.path.split("/")[this.$route.path.split("/").length - 2]
        ) {
          this.menuList = item;
          console.log(this.menuList, 64);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>